var React = require('react');

function Plunker (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 6.046A4.048 4.048 0 0 0 25.954 2H6.046A4.048 4.048 0 0 0 2 6.046v19.997a4.048 4.048 0 0 0 4.046 4.046h19.908A4.048 4.048 0 0 0 30 26.043V6.046Zm-2 0v19.997a2.047 2.047 0 0 1-2.046 2.046H6.046A2.047 2.047 0 0 1 4 26.043V6.046C4 4.917 4.917 4 6.046 4h19.908C27.083 4 28 4.917 28 6.046Z","key":0}),React.createElement("path",{"d":"M8 17.5V12l6 6V6.423h4V18l6-6v5.5L16 26l-8-8.5Z","key":1})]);
}

Plunker.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = Plunker;

Plunker.default = Plunker;
